(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode('._noPadding_183x1_1 .tippy-content{padding:0}.tippy-box[data-theme~=light]{box-shadow:var(--swui-shadow-popover)}.tippy-box[data-theme~=outlined]{border:1px solid var(--lhds-color-blue-500)}.tippy-box[data-theme~=info]{background-color:var(--lhds-color-blue-50);color:var(--swui-text-primary-color)}.tippy-box[data-theme~=info] .tippy-arrow{color:var(--lhds-color-blue-50)}.tippy-box[data-theme~=warning]{background-color:var(--lhds-color-orange-50);color:var(--swui-text-primary-color)}.tippy-box[data-theme~=warning] .tippy-arrow{color:var(--lhds-color-orange-50)}.tippy-box[data-theme~=error]{background-color:var(--lhds-color-red-50);color:var(--swui-text-primary-color)}.tippy-box[data-theme~=error] .tippy-arrow{color:var(--lhds-color-red-50)}.tippy-box[data-theme~=info][data-placement^=top]>.tippy-arrow:before{border-top-color:var(--lhds-color-blue-50)}.tippy-box[data-theme~=info][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:var(--lhds-color-blue-50)}.tippy-box[data-theme~=info][data-placement^=left]>.tippy-arrow:before{border-left-color:var(--lhds-color-blue-50)}.tippy-box[data-theme~=info][data-placement^=right]>.tippy-arrow:before{border-right-color:var(--lhds-color-blue-50)}.tippy-box[data-theme~=warning][data-placement^=top]>.tippy-arrow:before{border-top-color:var(--lhds-color-orange-50)}.tippy-box[data-theme~=warning][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:var(--lhds-color-orange-50)}.tippy-box[data-theme~=warning][data-placement^=left]>.tippy-arrow:before{border-left-color:var(--lhds-color-orange-50)}.tippy-box[data-theme~=warning][data-placement^=right]>.tippy-arrow:before{border-right-color:var(--lhds-color-orange-50)}.tippy-box[data-theme~=error][data-placement^=top]>.tippy-arrow:before{border-top-color:var(--lhds-color-red-50)}.tippy-box[data-theme~=error][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:var(--lhds-color-red-50)}.tippy-box[data-theme~=error][data-placement^=left]>.tippy-arrow:before{border-left-color:var(--lhds-color-red-50)}.tippy-box[data-theme~=error][data-placement^=right]>.tippy-arrow:before{border-right-color:var(--lhds-color-red-50)}.tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:8px;font-size:14px;line-height:1.5;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:"";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}.tippy-box[data-theme~=light]{color:#26323d;box-shadow:0 0 20px 4px #9aa1b126,0 4px 80px -8px #24282f40,0 4px 4px -2px #5b5e6926;background-color:#fff}.tippy-box[data-theme~=light][data-placement^=top]>.tippy-arrow:before{border-top-color:#fff}.tippy-box[data-theme~=light][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#fff}.tippy-box[data-theme~=light][data-placement^=left]>.tippy-arrow:before{border-left-color:#fff}.tippy-box[data-theme~=light][data-placement^=right]>.tippy-arrow:before{border-right-color:#fff}.tippy-box[data-theme~=light]>.tippy-backdrop{background-color:#fff}.tippy-box[data-theme~=light]>.tippy-svg-arrow{fill:#fff}.tippy-box[data-theme~=dark]{color:var(--lhds-color-ui-50);box-shadow:0 0 20px 4px #9aa1b126,0 4px 80px -8px #24282f40,0 4px 4px -2px #5b5e6926;background-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark][data-placement^=top]>.tippy-arrow:before{border-top-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark][data-placement^=left]>.tippy-arrow:before{border-left-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark][data-placement^=right]>.tippy-arrow:before{border-right-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark]>.tippy-backdrop{background-color:var(--lhds-color-ui-800)}.tippy-box[data-theme~=dark]>.tippy-svg-arrow{fill:var(--lhds-color-ui-800)}._tooltip_1i1mn_1{display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;align-items:center;border-radius:var(--swui-border-radius);padding:var(--swui-metrics-spacing) calc(var(--swui-metrics-indent) * 2)}._tooltip_1i1mn_1._withIcon_1i1mn_8{padding:calc(var(--swui-metrics-spacing) * .5);padding-right:calc(var(--swui-metrics-indent) * 2)}._iconWrapper_1i1mn_14{--current-bg-color: transparent;--current-border-color: var(--lhds-color-ui-50);--current-icon-color: var(--lhds-color-ui-50);display:inline-flex;flex-direction:row;white-space:nowrap;background-color:var(--current-bg-color);border:1px solid var(--current-border-color);border-radius:var(--swui-border-radius);padding:calc(var(--swui-metrics-spacing) * .5);align-items:flex-start}._iconWrapper_1i1mn_14 svg{color:var(--current-icon-color)}._iconWrapper_1i1mn_14._info_1i1mn_34{--current-border-color: var(--lhds-color-blue-300);--current-bg-color: var(--lhds-color-blue-100);--current-icon-color: var(--lhds-color-blue-700)}._iconWrapper_1i1mn_14._warning_1i1mn_40{--current-border-color: var(--lhds-color-orange-300);--current-bg-color: var(--lhds-color-orange-100);--current-icon-color: var(--lhds-color-orange-700)}._iconWrapper_1i1mn_14._error_1i1mn_46{--current-border-color: var(--lhds-color-red-300);--current-bg-color: var(--lhds-color-red-100);--current-icon-color: var(--lhds-color-red-700)}')),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { jsxs as c, jsx as n, Fragment as S } from "react/jsx-runtime";
import { Column as W, Text as h, Space as a, Row as p, Box as j } from "@stenajs-webui/core";
import { FlatButton as f, PrimaryButton as k, Spinner as B, Icon as N, stenaInfoCircle as R, stenaExclamationCircle as $, stenaExclamationTriangle as b } from "@stenajs-webui/elements";
import A from "@tippyjs/react";
import { useState as E, useMemo as F, useRef as M } from "react";
import m from "classnames";
import { cssColor as H } from "@stenajs-webui/theme";
const sn = ({
  text: o = "Are you sure?",
  yesLabel: t = "Yes",
  noLabel: i = "No",
  onNo: e,
  onYes: l,
  loading: r
}) => /* @__PURE__ */ c(W, { position: "relative", children: [
  /* @__PURE__ */ c("div", { style: { opacity: r ? 0 : 1 }, children: [
    /* @__PURE__ */ n(h, { children: o }),
    /* @__PURE__ */ n(a, {}),
    /* @__PURE__ */ c(p, { justifyContent: "flex-end", alignItems: "center", children: [
      /* @__PURE__ */ n(f, { label: i, onClick: e }),
      /* @__PURE__ */ n(a, {}),
      /* @__PURE__ */ n(k, { label: t, onClick: l })
    ] })
  ] }),
  r && /* @__PURE__ */ n(
    p,
    {
      justifyContent: "center",
      alignItems: "center",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      position: "absolute",
      children: /* @__PURE__ */ n(B, { size: "small" })
    }
  )
] }), L = "_noPadding_183x1_1", Y = {
  noPadding: L
};
const q = (o = []) => {
  const [t, i] = E(!1);
  return {
    plugins: [F(
      () => ({
        fn: () => ({
          onShow: () => i(!0),
          onHidden: () => i(!1)
        })
      }),
      [i]
    ), ...o],
    mounted: t
  };
}, D = {
  noPadding: Y.noPadding
}, u = {
  standard: "light",
  info: "info",
  warning: "warning",
  error: "error",
  outlined: "outlined"
}, _ = ({
  visible: o,
  trigger: t = "mouseenter",
  children: i,
  tippyRef: e,
  delay: l = 0,
  variant: r = "standard",
  disablePadding: d,
  content: y,
  maxWidth: w = "500px",
  plugins: x,
  lazy: P,
  arrow: v = !0,
  theme: I = "light",
  ...T
}) => {
  const { plugins: C, mounted: z } = q(x);
  return /* @__PURE__ */ n(
    A,
    {
      interactive: !0,
      className: D.noPadding,
      trigger: o !== void 0 ? void 0 : t,
      visible: o,
      theme: `${I} ${u[r] ?? u.standard}`,
      delay: l,
      maxWidth: w,
      arrow: v,
      content: (!P || z) && /* @__PURE__ */ n(j, { spacing: !d && 1, indent: !d && 1, children: y }),
      plugins: C,
      ...T,
      children: i && /* @__PURE__ */ n("div", { ref: e, children: i })
    }
  );
}, cn = ({
  children: o,
  onShow: t,
  onHide: i,
  ...e
}) => /* @__PURE__ */ n(
  _,
  {
    content: o,
    trigger: "click",
    zIndex: 1e3,
    onShow: t,
    onHide: i,
    children: /* @__PURE__ */ n(f, { ...e })
  }
), G = "_tooltip_1i1mn_1", J = "_withIcon_1i1mn_8", K = "_iconWrapper_1i1mn_14", O = "_info_1i1mn_34", Q = "_warning_1i1mn_40", U = "_error_1i1mn_46", s = {
  tooltip: G,
  withIcon: J,
  iconWrapper: K,
  info: O,
  warning: Q,
  error: U
}, V = {
  info: R,
  warning: $,
  error: b
}, g = ({ label: o }) => /* @__PURE__ */ n(h, { color: H("--lhds-color-ui-50"), size: "small", variant: "bold", children: o }), ln = ({
  label: o,
  variant: t,
  children: i,
  ...e
}) => /* @__PURE__ */ n(
  _,
  {
    theme: "dark",
    ...e,
    disablePadding: !0,
    content: /* @__PURE__ */ n("div", { className: m(s.tooltip, t ? s.withIcon : null), children: t ? /* @__PURE__ */ c(S, { children: [
      /* @__PURE__ */ n("div", { className: m(s.iconWrapper, s[t]), children: /* @__PURE__ */ n(N, { icon: V[t], size: 16 }) }),
      /* @__PURE__ */ n(a, {}),
      /* @__PURE__ */ n(g, { label: o })
    ] }) : /* @__PURE__ */ n(g, { label: o }) }),
    children: i
  }
), an = () => {
  const o = M();
  return [
    (t) => {
      o.current = (t == null ? void 0 : t._tippy) ?? void 0;
    },
    o
  ];
};
export {
  sn as ActionPrompt,
  cn as ButtonWithPopover,
  _ as Popover,
  ln as Tooltip,
  D as tippyStyles,
  an as useTippyInstance
};
//# sourceMappingURL=index.es.js.map
